<template>
	<form class="form" @submit.prevent="sendToPreview" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Supporting Documents</legend>

			<FileUpload id="documents" v-model="formData.documents" name="documents" multiple="true"></FileUpload>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit", "documents uploading"]'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='["submit", "documents uploading"]'>Save &amp; Preview</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import OpportunityFormStep from './OpportunityFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FileUpload from '../../Form/FileUpload';

	export default {
		name: 'OpportunityFormStep5',
		mixins: [OpportunityFormStep],
		components: {
			FileUpload,
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					documents: [],
				}
			}
		},
	}
</script>
